import { parse, format, startOfMonth, addMonths } from "date-fns";

export const getParsedDateObj = (date: string) =>
  parse(date, "yyyy-MM-dd", new Date());

export const getStringifiedDate = (date: Date) => format(date, "yyyy-MM-dd");

export const getNextMonthStart = (date: Date) =>
  startOfMonth(addMonths(date, 1));
